const toNumber = (value) => Number(value ?? 0) || 0;
export const roundMoney = (value) =>
  Math.round((toNumber(value) + Number.EPSILON) * 100) / 100;

const buildFallbackRows = (items = [], finalTotal = 0) => {
  const rows = items.map((item) => ({
    productName: item.productName,
    weight: toNumber(item.netWeight),
    total: toNumber(item.netPrice),
  }));
  const sourceTotal = rows.reduce((sum, row) => sum + row.total, 0);
  const targetTotal = toNumber(finalTotal);
  const ratio = sourceTotal && targetTotal ? targetTotal / sourceTotal : 1;

  return rows.map((row) => {
    const total = roundMoney(row.total * ratio);
    return {
      ...row,
      total,
      pricePerUnit: row.weight ? total / row.weight : 0,
    };
  });
};

// The Buy page displays transactionBreakdown.details. PDFs must use that same
// source instead of recalculating from the possibly stale transaction items.
export const buildInvoiceRows = ({
  items = [],
  transactionBreakdown = [],
  fallbackTotal = 0,
} = {}) => {
  if (!Array.isArray(transactionBreakdown) || transactionBreakdown.length === 0) {
    return buildFallbackRows(items, fallbackTotal);
  }

  const breakdownByIndex = new Map(
    transactionBreakdown.map((row, index) => [
      Number.isInteger(row?.index) ? row.index : index,
      row,
    ]),
  );

  return items.map((item, index) => {
    const breakdown = breakdownByIndex.get(index) || transactionBreakdown[index];
    const details = Array.isArray(breakdown?.details) ? breakdown.details : [];
    const weight = details.length
      ? details.reduce((sum, detail) => sum + toNumber(detail?.usedWeight), 0)
      : toNumber(breakdown?.originalItem?.netWeight ?? item.netWeight);
    const total = details.length
      ? details.reduce(
          (sum, detail) => sum + roundMoney(detail?.totalPrice),
          0,
        )
      : roundMoney(breakdown?.totalPrice ?? item.netPrice);

    return {
      productName: breakdown?.productName ?? item.productName,
      weight,
      // ใช้กติกาเดียวกับยอดสุทธิหน้า Buy: ปัดยอดแต่ละ detail ก่อนรวม
      total: roundMoney(total),
      pricePerUnit: weight ? total / weight : 0,
    };
  });
};
